var _defs, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 102,
    height: 100,
    viewBox: "0 0 102 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    id: "master_svg_0",
    gradientTransform: "translate(22.5 46.833068042993546) rotate(0.589119216219359) scale(30.87711949261041 30.159510389641202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#000000",
    stopOpacity: 0.6000000238418579
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99.99985098838806%",
    stopColor: "#9E9E9E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    id: "master_svg_1",
    gradientTransform: "translate(81.5 50.5) rotate(180) scale(27.822937175631523 28.242662230101217)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#000000",
    stopOpacity: 0.30000001192092896
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100.00009536743164%",
    stopColor: "#9E9E9E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    id: "master_svg_2",
    gradientTransform: "translate(69.86755366623402 51.91244697570801) rotate(92.1210888755845) scale(17.15460263963477 16.313654880555653)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFFFFF",
    stopOpacity: 0.6000000238418579
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFFFFF",
    stopOpacity: 0
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "passthrough"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "passthrough"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "passthrough"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7656,33.3144L22.0938,33.3144C28.375,33.3144,31.7969,35.1269,31.7969,40.5488C31.7969,45.8769,28.375,48.58,22.0938,48.58L15.7656,48.58L15.7656,33.3144ZM43.4844,74.58L32.0625,54.7988C37.6719,52.6113,41.375,48.0488,41.375,40.5488C41.375,29.1581,33.25,25.58,23.0312,25.58L6,25.58L6,74.58L15.7656,74.58L15.7656,56.3144L22.5625,56.3144L32.5938,74.58L43.4844,74.58Z",
    fill: "url(#master_svg_0)",
    fillOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "passthrough"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2812,33.82L21.4375,33.82C27.5156,33.82,30.8438,35.5544,30.8438,40.6794C30.8438,45.7575,27.5156,48.32,21.4375,48.32L15.2812,48.32L15.2812,33.82ZM42.1719,73.32L31.0938,54.3356C36.5312,52.2262,40.125,47.82,40.125,40.6794C40.125,29.7887,32.25,26.32,22.3281,26.32L5.8125,26.32L5.8125,73.32L15.2812,73.32L15.2812,55.82L21.875,55.82L31.6094,73.32L42.1719,73.32Z",
    fill: "#5B71DF",
    fillOpacity: 1
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "passthrough"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8125,54.6169C57.1406,54.6169,59.625,51.9294,59.625,48.5387C59.625,45.0231,57.1406,42.32,53.8125,42.32C50.4844,42.32,47.9219,45.0231,47.9219,48.5387C47.9219,51.9294,50.4844,54.6169,53.8125,54.6169Z",
    fill: "#A49292",
    fillOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "passthrough"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "passthrough"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67,75.58L97.6875,75.58L97.6875,67.4081L76.7656,67.4081L76.7656,54.58L93.9219,54.58L93.9219,46.4081L76.7656,46.4081L76.7656,34.705L96.9531,34.705L96.9531,26.58L67,26.58L67,75.58Z",
    fill: "url(#master_svg_1)",
    fillOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "passthrough"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8125,73.32L98.5781,73.32L98.5781,65.3981L78.2812,65.3981L78.2812,53.2575L94.9219,53.2575L94.9219,45.32L78.2812,45.32L78.2812,34.195L97.875,34.195L97.875,26.32L68.8125,26.32L68.8125,73.32Z",
    fill: "#14C5AE",
    fillOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "passthrough"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8125,73.32L98.5781,73.32L98.5781,65.3981L78.2812,65.3981L78.2812,53.2575L94.9219,53.2575L94.9219,45.32L78.2812,45.32L78.2812,34.195L97.875,34.195L97.875,26.32L68.8125,26.32L68.8125,73.32Z",
    fill: "url(#master_svg_2)",
    fillOpacity: 1
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.204f4024266c5c4ed14b824e7cb03c1f.svg";
export { ForwardRef as ReactComponent };